export default __webpack_public_path__ + "static/media/stock.43aabd35.png";